import * as React from 'react'
export const TwitterIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_1752_1855)'>
        <path
          d='M16.0168 0.960938H19.0836L12.3835 8.61866L20.2656 19.0391H14.094L9.2602 12.7191L3.7292 19.0391H0.660563L7.82692 10.8483L0.265625 0.960938H6.59391L10.9633 6.7376L16.0168 0.960938ZM14.9405 17.2035H16.6398L5.67051 2.70016H3.84692L14.9405 17.2035Z'
          fill='current'
        />
      </g>
      <defs>
        <clipPath id='clip0_1752_1855'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
